(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('other-event', {
            parent: 'entity',
            url: '/other-event?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.otherEvent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/other-event/other-events.html',
                    controller: 'OtherEventController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('otherEvent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('other-event-detail', {
            parent: 'entity',
            url: '/other-event/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.otherEvent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/other-event/other-event-detail.html',
                    controller: 'OtherEventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('otherEvent');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OtherEvent', function($stateParams, OtherEvent) {
                    return OtherEvent.get({id : $stateParams.id});
                }]
            }
        })
        .state('other-event.new', {
            parent: 'other-event',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/other-event/other-event-dialog.html',
                    controller: 'OtherEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                description: null,
                                dateFrom: null,
                                dateTo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('other-event', null, { reload: true });
                }, function() {
                    $state.go('other-event');
                });
            }]
        })
        .state('other-event.edit', {
            parent: 'other-event',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/other-event/other-event-dialog.html',
                    controller: 'OtherEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OtherEvent', function(OtherEvent) {
                            return OtherEvent.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('other-event', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('other-event.delete', {
            parent: 'other-event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/other-event/other-event-delete-dialog.html',
                    controller: 'OtherEventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OtherEvent', function(OtherEvent) {
                            return OtherEvent.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('other-event', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
